import { Component, AfterViewInit, Input, SimpleChanges, OnChanges } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexNonAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexStroke,
  ApexFill,
  ApexLegend,
  ApexTooltip,
  ApexMarkers,
  ApexPlotOptions,
  ApexResponsive,
  ApexGrid,
  ApexAnnotations,
  ApexStates,
  ApexTheme,
  NgApexchartsModule,
} from 'ng-apexcharts';

export type ChartOptions = {
  series?: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart?: ApexChart;
  xaxis?: ApexXAxis;
  yaxis?: ApexYAxis | ApexYAxis[];
  title?: ApexTitleSubtitle;
  subtitle?: ApexTitleSubtitle;
  dataLabels?: ApexDataLabels;
  stroke?: ApexStroke;
  fill?: ApexFill;
  legend?: ApexLegend;
  tooltip?: ApexTooltip;
  markers?: ApexMarkers;
  plotOptions?: ApexPlotOptions;
  responsive?: ApexResponsive[];
  grid?: ApexGrid;
  annotations?: ApexAnnotations;
  states?: ApexStates;
  theme?: ApexTheme;
  colors?: string[];
  labels?: any;
};

@Component({
  selector: 'app-graficas',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './graficas.html',
  styleUrl: './graficas.scss',
})
export class Graficas implements OnChanges, AfterViewInit {
  @Input({ required: true }) titulo!: string;

  @Input({ required: true }) unidad!: string;

  @Input() tipo: 'line' | 'bar' | 'scatter' | 'area' = 'line';

  @Input() series!: ApexAxisChartSeries;

  @Input() colores: string[] = ['#24575A'];

  public chartOptions: Partial<ChartOptions> = {
    series: [],

    chart: {
      height: '100%',
      width: '100%',
      type: 'line',

      dropShadow: {
        enabled: true,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2,
      },
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },

    colors: ['#2F6F73', '#545454'],

    dataLabels: {
      enabled: true,
      background: {
        enabled: true,
        borderRadius: 10,
        padding: 10,
        opacity: 1,
        borderWidth: 0,
      },
    },

    stroke: {
      curve: 'smooth',
    },

    markers: {},

    title: {
      text: '',
      align: 'center',
      style: {
        fontSize: '24px',
        fontWeight: 'bold',
      },
    },

    xaxis: {
      type: 'datetime',
      title: {
        text: 'Fecha',
        style: {
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#24575A',
        },
      },

      labels: {
        style: {
          fontSize: '14px',
          colors: '#333',
        },
        datetimeFormatter: {
          day: 'dd/MM',
        },
      },
    },

    yaxis: {
      title: {
        text: 'Peso [kg]',
        style: {
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#24575A',
        },
      },

      labels: {
        style: {
          fontSize: '14px',
          colors: '#333',
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '14px',
      },
    },
  };

  ngOnChanges(changes: SimpleChanges): void {
    this.chartOptions = {
      ...this.chartOptions,

      series: this.series,

      colors: this.colores,

      chart: {
        ...this.chartOptions.chart,
        type: this.tipo,
      },

      title: {
        ...this.chartOptions.title,
        text: this.titulo,
      },

      yaxis: {
        ...(this.chartOptions.yaxis as ApexYAxis),
        title: {
          text: `${this.titulo} [${this.unidad}]`,
          style: {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#24575A',
          },
        },
      },

      tooltip: {
        ...this.chartOptions.tooltip,
        y: {
          formatter: (value: number) => `${value} ${this.unidad}`,
        },
      },
    };
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if ((window as any).ApexCharts) {
        (window as any).ApexCharts.setLicense(
          'APEX-eyJpc3N1ZURhdGUiOiIyMDI2LTA0LTE2IiwiZXhwaXJ5RGF0ZSI6IjIwNTItMDQtMTciLCJwbGFuIjoiZW50ZXJwcmlzZSIsImRvbWFpbnMiOlsiYXBleGNoYXJ0cy5jb20iLCIxMjcuMC4wLjEiXX0=',
        );
      }
    }, 100);
  }
}
